import { useState, useEffect } from "react";
import provOptions from "../../util/defaults/provincias";

function useEmployeeProvincesOptions(businessCountry: string) {
  const [provincesOptions, setProvincesOptions] = useState(
    [] as { value: string; label: string }[]
  );

  useEffect(() => {
    const newProvs: { value: string; label: string }[] = [];
    let filter = "es";
    if (businessCountry === "fr") {
      filter = "fr";
    }

    // eslint-disable-next-line
    provOptions.map((item: any) => {
      if (item.businessCountry === filter) {
        newProvs.push({
          value: item.value,
          label: item.value,
        });
      }
    });

    setProvincesOptions(newProvs);
  }, [businessCountry]);

  return provincesOptions;
}

export default useEmployeeProvincesOptions;
